import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { languageLable } from "utilities/helpers";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CountryStateSelector from "./CountryStateSelector";
import API from "api/api";
import RegisterFormField from "./RegisterFormField";

const api = new API();

export default function Register() {
  const [loading, setLoading] = useState(false);
  const [doctorHospitals, setDoctorHospitals] = useState([]);
  const [customerTypes, setCustomerTypes] = useState([]);
  const [countryState, setCountryState] = useState(null);
  const appState = useSelector((state) => state);
  const { selectedLanguageData } = appState?.app;
  const { authToken } = appState?.auth;

  const handleCountySelector = async (values) => {
    setCountryState(values);
    setLoading(true);

    try {
      const res = await api.get(
        `GetIntegratedCustomersBy?stateName=${values.state}&countryName=${values.country}`
      );
      if (
        res.Result &&
        typeof res.Result === "object" &&
        res.Result.length > 0
      ) {
        setDoctorHospitals(res.Result);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const getCustomerType = async () => {
    try {
      const res = await api.get(`GetCustomerTypes`);
      if (res.Result) {
        setCustomerTypes(res.Result);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (authToken) getCustomerType();
  }, [authToken]);

  return (
    <div className="ps-my-account register-wrapper">
      <div className="container">
        <div className="ps-form--account">
          <ul className="ps-tab-list">
            <li>
              <Link to="/account/login">
                {languageLable(selectedLanguageData, "Login")}
              </Link>
            </li>
            <li className="active">
              <Link to="/account/register">
                {languageLable(selectedLanguageData, "Register")}
              </Link>
            </li>
          </ul>
          <div className="ps-tab active" id="register">
            <div className="ps-form__content">
              <h3 className="register-title">Create Account</h3>
              <h5>
                {languageLable(
                  selectedLanguageData,
                  `Enter Below details to create new profile for access the application features.`
                )}
              </h5>

              {/* {!countryState ? (
                <Spin spinning={loading}>
                  <CountryStateSelector
                    handleCountySelector={handleCountySelector}
                  />
                </Spin>
              ) : ( */}
                <RegisterFormField
                  doctorHospitals={doctorHospitals}
                  customerTypes={customerTypes}
                />
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
